module.exports = __webpack_public_path__ + "assets/ac7e51c27ea6e6930d130e2e54d18235.mp3";